import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

export default function AlertError({ text, dashboardButton = true, onRetry }) {
  return (
    <div
      className="admin-theme flex min-h-[60vh] min-h-0 flex-1 flex-col items-center justify-center gch-layout-bg px-4"
      style={{ fontFamily: '"Inter", sans-serif' }}
    >
      <div className="w-full max-w-md rounded-xl border border-[var(--admin-border)] gch-bg-card p-8 shadow-sm">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white/5">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-500" aria-hidden="true" />
          </div>
          <h1
            className="mb-2 text-lg font-semibold gch-text-primary"
            style={{ fontFamily: '"Lexend", sans-serif' }}
          >
            Something went wrong
          </h1>
          <p className="mb-6 text-sm leading-relaxed gch-text-secondary">{text}</p>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            {onRetry && (
              <button
                onClick={onRetry}
                className="btn-admin-primary btn-admin-md inline-flex items-center justify-center gap-2 w-full sm:w-auto"
              >
                Try Again
              </button>
            )}
            {dashboardButton && (
              <Link
                to="/studio/dashboard"
                className={`${onRetry ? 'btn-admin-secondary' : 'btn-admin-primary'} btn-admin-md inline-flex items-center justify-center gap-2 w-full sm:w-auto`}
              >
                Go to Dashboard
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
